import { render } from "./S74149.vue?vue&type=template&id=8788bac8"
const script = {}
script.render = render

export default script